import axios from 'axios'
const qs = require('qs');
import appENV from './env';
import Vue from 'vue'
import { cookie,queryString ,queryObj} from '@/assets/js/utils'          
// let baseURL = 'https://prod.odmkf.com/third-test/zy-sdcj2022/api/';//测试环境接口
let baseURL = '/zhongyin/cj2023/api/';//生产地址接口
if(process.env.NODE_ENV == 'development'){
    baseURL= `http://${location.hostname}:${location.port}/third-test/zy-cj2023/api/`
}
function _api(){

    let api = axios.create({
        baseURL,
        timeout: 15000,
        headers:{
            'content-type':'application/x-www-form-urlencoded'  //默认值
        },
    });

    api.interceptors.response.use(function (res) {
        console.log('====',res)
        if(res.data.code == 200 && res.config.url == '/actData'){
            window.actId = res.data.data.actId;
        }else if(res.data.code == 199){
            // bizUtils.logout();
            let actid = 0;
            try {
                let query = queryString(res.config.data);
                actid = query.actId;
            } catch (error) {
                
            }
            if(actid){
                cookie.set('token'+actid,'',-1);
                cookie.set('shareKey'+actid,'',-1);
                cookie.set('query'+actid,'',-1);
                cookie.set('fromPlat','',-1);
            }
            // let t = setTimeout(()=>{
            //     clearTimeout(t);
            //     // location&&location.reload();
            // }, 50)
            
            
            // location.href = location.href.substr(0,location.href.indexOf('#')) +'#/login'
        }
        return res;
      }, function (error) {
        // 对响应错误做点什么
        return Promise.reject(error);
      });
    
      return api
}




let md5 = require("./sign.min");
// console.log(md5)
function sign(o){
    var a=Object.keys(o).sort(),b=[];
    for(var i=0;i<a.length;i++){
        if(a[i]!="_s"){
        b.push(a[i]+'='+o[a[i]])
        }
    }
    // console.log(md5(encodeURIComponent(b.join('|'))))
    return '1'+md5(encodeURIComponent(b.join('|')))
}
 async function api(mode='post', path, opt ){
    
    //  let fromPlat = await appENV();
    let query = location.href.substr(location.href.indexOf('?'))
    let actId = queryString(query) && queryString(query).__sa || (window && window.actId);
    Vue.prototype.$actId = actId;
    let token = cookie.get('token'+actId) || '';
    let fromPlat = cookie.get('fromPlat') || await appENV.catch(err => {
        // console.log(err)
    })
    let data = {
        actId, // 
        token,
        _t: new Date().getTime(),
        _ctkey: localStorage && localStorage.getItem('_ctkey'),
        fromPlat // 1=微信 2=中行APP 3=中银APP
    }

    data = Object.assign({}, data, opt);
    data['_s'] = sign(data);
    
    console.log("签名后请求参数：",data)
    if(mode == 'post'){
        return _api().post(path, qs.stringify(data))
    }else{
        return _api().get(path, {params: data})
    }
    
}
export default api
